"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "16",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M11 7h2v7h-2z"
}, "2")], 'ReportGmailerrorredOutlined');